'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var typeCheck_1 = require("../../shared/utils/typeCheck");
var Messenger;
(function (Messenger) {
    function send(parentWindow, event, options) {
        if (parentWindow !== window) {
            parentWindow.postMessage(JSON.stringify({ event: event, options: options }), '*');
        }
    }
    Messenger.send = send;
    function listen(event, listener) {
        window.addEventListener('message', function (e) {
            var data = null;
            if (typeCheck_1.TypeCheck.json(e.data)) {
                data = JSON.parse(e.data);
            }
            if (data && data.event === event) {
                listener(data.options);
            }
        }, false);
    }
    Messenger.listen = listen;
})(Messenger = exports.Messenger || (exports.Messenger = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/messenger.ts
// module id = 45
// module chunks = 1 2